// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35WGA","colMin":"styles_colMin__WlG04"};